import React from "react";
import FormRepeater from "../../../../../common/FormReapeater";
import {Input, Select} from "../../../../../common/inputs";

const RaportParamRepeater = ({form, setFormState}) => {

    //@ Opcje typ wartości
    const options = [
        {id: 'numeric', value: 'numer'},
        {id: 'string', value: 'string'},
        {id: 'boolean', value: 'boolean'},
        {id: 'date', value: 'data'},
    ]


    return <FormRepeater
        className={'mt-2'}
        addButtonTitle={'dodaj parametr'}
        addButtonText={'Dodaj parametr'}
        deleteBtnSize={'sm'}
        // debug
        deleteBtnPos={'end'}
        onChange={(e) => {
            setFormState('parametry', e.map((i, idx) => {
                    return {
                        ...i,
                        sort: idx + 1,
                        value: {[i.nazwa]: i.wartosc}
                    }
                }
            ))
        }
        }
        value={form.parametry || []}
        form={(row, setRow, idx) => {

            return (
                <>
                    <Input
                        label={
                            idx === 0
                                ? 'Nazwa parametru'
                                : ' '
                        }
                        value={row.nazwa || ''}
                        // errorText={errors[`list.${idx}.nazwa`]?.[0]}
                        onChange={(e) => {
                            setRow('nazwa', e.target.value)
                            // setRow('sort', idx + 1)
                            // setRow('value', {[e.target.value]: row.wartosc})

                        }}
                        name={'nazwa'}
                    />

                    <Select
                        label={
                            idx === 0 ? 'Typ parametru' : ' '
                        }
                        className={'w-50'}
                        // errorText={errors[`list.${idx}.typ`]?.[0]}
                        value={row.wartosc_typ || ''}
                        options={options}
                        onChange={(e) => {
                            setRow('wartosc_typ', e.target.value)
                            // setRow('value', {[row.nazwa]: row.wartosc})
                        }}
                        name={'wartosc_typ'}
                    />

                    <Input

                        label={
                            idx === 0
                                ? 'Wartość parametru'
                                : ' '
                        }

                        // errorText={errors[`list.${idx}.wartosc`]?.[0]}
                        value={row.wartosc || ''}
                        onChange={(e) => {
                            setRow('wartosc', e.target.value)
                            // setRow('value', {[row.nazwa]: row.wartosc})
                        }}
                        name={'wartosc'}
                    />

                    <Input
                        label={
                            idx === 0
                                ? 'Opis parametru                      '
                                : ' '
                        }
                        className={'flex-fill'}
                        // errorText={errors[`list.${idx}.opis`]?.[0]}
                        value={row.opis || ''}
                        onChange={(e) => {
                            setRow('opis', e.target.value)
                        }}
                        name={'opis'}
                    />
                </>

            )
        }}
    />

}

export default RaportParamRepeater